import React from 'react';
import BSTableContainer from './components/BSTableContainer';
import BSTable from './components/BSTable';
import { Button, TableBody, TableHead } from '@mui/material';
import BSTableRow from './components/BSTableRow';
import BSTableHeaderCell from './components/BSTableHeaderCell';
import BSTableBodyCell from './components/BSTableBodyCell';

const TournamentTable = ({ tournaments, onEdit, onDelete }) => {
  return (
    <BSTableContainer>
      <BSTable>
        <TableHead>
          <BSTableRow>
            <BSTableHeaderCell>Tournament Name</BSTableHeaderCell>
            <BSTableHeaderCell>Start Date</BSTableHeaderCell>
            <BSTableHeaderCell>End Date</BSTableHeaderCell>
            <BSTableHeaderCell>Actions</BSTableHeaderCell>
          </BSTableRow>
        </TableHead>
        <TableBody>
          {tournaments.map((tournament) => (
            <BSTableRow key={tournament.id}>
              <BSTableBodyCell>{tournament.name}</BSTableBodyCell>
              <BSTableBodyCell>
                {new Date(tournament.startDate).toLocaleDateString()}
              </BSTableBodyCell>
              <BSTableBodyCell>{new Date(tournament.endDate).toLocaleDateString()}</BSTableBodyCell>
              <BSTableBodyCell>
                <Button onClick={() => onEdit(tournament.id)}>Edit</Button>
                <Button onClick={() => onDelete(tournament.id)}>Delete</Button>
              </BSTableBodyCell>
            </BSTableRow>
          ))}
        </TableBody>
      </BSTable>
    </BSTableContainer>
  );
};

export default TournamentTable;
